import styled from 'styled-components';
import { LoadingLineChartProps } from './loadingLineChart';

export const LineCharContainer = styled.div`
  padding: 0.5rem 1rem 0.3rem 1rem;
  background-color: var(--white);
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  text-align: right;
`;

export const LineChartHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
`;

export const LineChartInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 0.5rem;

  .heading-line {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
`;

export const LineChartFilters = styled.div`
  display: flex;
  width: 30%;
`;

export const LineCharContainerLoading = styled.div<LoadingLineChartProps>`
  padding: 0.5rem 1rem 0.3rem 1rem;
  background-color: var(--white);
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${({ height }) => (height ? height : '100%')};
`;
